import { Resourceful, Resourceful2 } from "../../ResourceManager/Resourceful";
import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, LoadingStage, ResourceManager } from "../../ResourceManager/ResourceManager";
import { ScreenProtocolScope, ScreenProtocol } from "../../ScreenProtocol";
import { LogGroup } from "../.././MyHelpers";
import { BonusFinish, IBonusStartConfig } from "../SlotGame";
import { BonuRecoverStatus } from "./SlotBonus";
import { SlotBonusParams } from "./SlotBonusParams";

export abstract class SlotBonus2 implements Resourceful2
{
	protected gameName: string = "";
	protected bonusName: string = "";
	protected logGroup: LogGroup = null;

	// resource identifier to prevent resource clash
	protected gameresid: ResourceIdentifier = null;
	protected resid: ResourceIdentifier = null;
	protected classid: string = "";


	protected screenProtocolScope: ScreenProtocolScope = null;
	protected screenProtocol: ScreenProtocol = null;

	protected abstract BonusName(): string;

	public constructor(gameName: string, params: SlotBonusParams) {
		this.gameName = gameName;
		this.bonusName = this.BonusName();

		//this.logGroup = gameName + "|" + bonusName;
		//this.classid = gameName + "-" + bonusName;
		//this.resid = gameName + "." + bonusName;

		this.gameresid = params.resid;
		this.resid = params.resid.Add(this.bonusName + "2");
		this.logGroup = params.logGroup.Add(this.bonusName + "2");

		this.screenProtocolScope = params.screenProtocolScope.Add(this.bonusName);
		this.screenProtocol = params.screenProtocol;
	}

	public abstract ResourcesLoaded(loadingStage: LoadingStage, resourceManager: IReadOnlyResourceManager): Promise<void>;

	public abstract PrepareResources(loadingStage: LoadingStage, resourceManager: IWriteOnlyResourceManager): Promise<void>;


	// notify bonus, that trigger animation has started
	public TriggerAnimationStarted(): void {}
	public TriggerAnimationStopped(): void {}

	// messages from backend

	// signal, that bonus has finished
	public abstract OnBonusFinish(bonusFinish: BonusFinish): void;

	//public abstract Recover(lastGame: IHistoryEntry, bonusStartConfig: IBonusStartConfig): void;
	public abstract Prepare(bonusStartConfig: IBonusStartConfig): void;
	public abstract Hide():void;
	public abstract Show():void;
	public abstract Update():void;

	public abstract View():HTMLElement;

	public abstract Start():void;
	public abstract Stop():void;

	public abstract Reset(): void;
}